'use client';

import { Modal } from '@/app/components/Modal';
import { BaseButton } from '@/app/components/buttons/BaseButton';

interface EmailRequiredForFormsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const EmailRequiredForFormsModal = ({ isOpen, onClose }: EmailRequiredForFormsModalProps) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="px-[36px] py-[46px] flex flex-col items-center text-center max-w-[454px]">
        <h2 className="light text-blue-900 mb-1.5">Email required</h2>
        <p className="text-body-regular text-grey-700">
          This client does not have an email address. Add an email to the profile before sending forms.
        </p>
        <div className="flex gap-5 w-full mt-9">
          <BaseButton intent="primary" onClick={onClose} size="full">
            Got it
          </BaseButton>
        </div>
      </div>
    </Modal>
  );
};
